
import page from "~/layouts/testimonial.vue";

export default {
  components: {
    page,
  },

  data() {
    return {
      itemsAdvantage: [
        {
          principal: "Développer sa visibilité pour un rayonnement cosmique",
        },
        {
          principal: "Présenter la meilleure image possible",
        },
        {
          principal: "Donner accès aux bonnes infos ",
        },
        {
          principal: "Fidéliser ses clients",
        },
        {
          principal: "Obtenir plus de contacts",
        },
      ],
      itemsAdvantage2: [
        {
          principal: "Fidélisation client",
        },
        {
          principal: "Développement de la notoriété",
        },
        {
          principal: "Accroissement des nouveaux contacts.",
        },
      ],
    };
  },

  head() {
    return {
      title: "Création de site internet pour Hôtel | Agence ALEO",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "L’Hôtel Restaurant Moschenross accueille ses clients dans un cadre idyllique au cœur des vignes. Voulant un site d'exception, il s’est tourné vers nous !",
        },
        {
          hid: "og:title",
          property: "og:title",
          content: "Graphisme, Site web & Référencement",
        },
        {
          hid: "og:description",
          property: "og:description",
          content: "Centre de Médecine Esthétique des Glacis témoigne",
        },
        // {
        //   hid: "og:image",
        //   property: "og:image",
        //   content: require("~/assets/img/case-studies/mockup-moschenross.jpg"),
        // },
      ],
    };
  },
};
